import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DoctorDatapoint from "../DoctorDatapoint/DoctorDatapoint";
import Button from "../../../ui/Button/Button";
import { convertObjectToArray } from "../../../util/arraysUtil";
import Container from "../../../ui/Container/Container";
import "./DoctorInfo.css";

function DoctorInfo() {
  const location = useLocation();
  const navigate = useNavigate();
  const doctor = location.state.doctor;

  function optionPressed() {
    if (doctor.patients) {
      const patients = convertObjectToArray(doctor.patients);
      navigate("/adminPatientsList", { state: { data: patients, doctor } });
    } else {
      alert("El doctor no tiene pacientes registrados en este momento");
    }
  }

  return (
    <Container title={"Información del doctor"} backNavigation={"/initAdmin"}>
      <div className="dInfoButtonContainer">
        <Button onPress={optionPressed}>Ver pacientes</Button>
      </div>
      <div className="diInfoContainer">
        <DoctorDatapoint
          label={"Nombre"}
          data={`${doctor.name} ${doctor.lastName} ${doctor.surName}`}
        />
        <DoctorDatapoint label={"Especialidad"} data={`${doctor.speciality}`} />
        <DoctorDatapoint
          label={"Cédula profesional"}
          data={`${doctor.cardId}`}
        />
        <DoctorDatapoint
          label={"Correo electrónico"}
          data={`${doctor.email}`}
        />
        <DoctorDatapoint
          label={"Teléfono de oficina"}
          data={`${doctor.officePhone}`}
        />
        <DoctorDatapoint
          label={"Teléfono celular"}
          data={`${doctor.cellPhone}`}
        />
        <DoctorDatapoint
          label={"Doctor de prueba"}
          data={`${!doctor.isTest ? "Doctor real" : "Doctor de prueba"}`}
        />
        <DoctorDatapoint label={"Doctor Key"} data={`${doctor.key}`} />
      </div>
    </Container>
  );
}

export default DoctorInfo;
